import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";

import { FC } from "react";

export interface SectionHero4Props {
  className?: string;
}

const SectionHero4: FC<SectionHero4Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col items-center">
        {/* <div className="hidden flex-shrink-0 lg:flex flex-col items-start pb-4 lg:pb-48 justify-center text-center">
          <span className="font-bold text-6xl text-white mb-16 md:mb-4 text-center leading-snug">
            Ride in Style
            <br />
            <span className="text-7xl">That Suits You</span>
          </span>
        </div> */}
      </div>
      <div className="hidden lg:block mt-24 z-10  w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero4;
